import { Link } from "gatsby";
import React from "react";
import { Col, Container, Row } from "reactstrap";
// eslint-disable-next-line import/no-unresolved
import SEO from "../General/SEO";
// eslint-disable-next-line import/no-unresolved
import { StickyTop } from "../General/StickyTop";
import PostArticlesEntry from "./post-articles-entry";

const ArticlesTemplate = ({ cat, archivePath, nodes, cats, nextPath, previousPath }) => {
  return (
    <div>
      <SEO
        title={`${cat ? `${cat}` : "Articles"}`}
        description={`Psychedelic Support articles ${
          cat ? `about ${cat}` : ""
        } are written by our community and global network of health providers. Find the latest perspectives on Psychedelic Research, Therapy and Integration.`}
        pathname={archivePath}
      />
      <Container className="archive overflow-anchor-none">
        <Row>
          <Col>
            <h1>{`${cat ? `${cat}` : "Articles"}`}</h1>
            <div className="mt-5">
              Dive into our free and extensive library of articles from health professionals and the psychedelic
              community!
            </div>
          </Col>
        </Row>
        <StickyTop>
          <div className="archive-sticky">
            <Row className="cat-links pt-4">
              {cats &&
                cats.map((c, index) => (
                  <Col className="mt-2" xs="auto" key={index}>
                    <Link className={`alink ${c.name === cat ? "active" : ""}`} to={`/articles/category/${c.slug}/`}>
                      {c.name}
                    </Link>
                  </Col>
                ))}
            </Row>
            <div className="divider" />
          </div>
        </StickyTop>
        <Row className="mt-5">
          {nodes &&
            nodes.map((post) => (
              <Col className="archive-card-wrapper" md="6" lg="4" key={post.id}>
                <PostArticlesEntry post={post} />
              </Col>
            ))}
        </Row>
        <Row className="mt-4">
          <Col className="d-flex justify-content-between">
            {previousPath && (
              <div>
                <Link to={previousPath}>Newer Posts</Link>
              </div>
            )}
            {nextPath && (
              <div className="ms-auto">
                <Link to={nextPath}>Older Posts &#10140;</Link>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ArticlesTemplate;
